import { useEffect } from "react";
import Header from "../../components/AdminPortal/Header/Header";
import QuizzesComponents from "../../components/AdminPortal/Quizzes/Quizzes";
export default function Quizzes() {
  useEffect(() => {
    document.title = "Quizzes - LWS Learning Portal";
  }, []);
  return (
    <>
      <Header />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <QuizzesComponents />
        </div>
      </section>
    </>
  );
}
